import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import PageTooltip from "../components/Tooltip"
import { passwordMail, recoveryError } from '../hooks/auth'

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}


const mapDispatchToProps = dispatch => ({
  passwordMail: (data) => dispatch(passwordMail(data)),
  recoveryError: () => dispatch(recoveryError())
});

class ForgetPassword extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      email: "",
      error: null,
      recovery_error: false,
      button_disable: false,
      mail_sent: false
    };

  }

  componentDidUpdate() {
    if (this.props.auth.recovery !== null) {
      this.props.recoveryError()
      this.setState({recovery_error:true})
    }
  }
  
  handleChange = (e) => {
    this.setState({
      [e.target.name]:e.target.value,
      error: null,
      recovery_error:false
    })
  }
  submitForm = () => {
    var state =this.state
    if (state.email == null || state.email == "") {
      this.setState({error: "Required"})
    }else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(state.email)) {
      this.setState({error: "invalid email address"})
    } else {
      this.props.passwordMail({"email": this.state.email})
      this.setState({button_disable: true})
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.setState({button_disable: false})
      }, 10000)
    }
  }
  
  render() {
    
    return <Fragment>

      <NavbarComp/>
      <div className="page-sections">
        <div className='forget-pass-wrap'>
          <Container>
            <div className='forget-pass-contents'>
              <h2 className='main-title-style'>FORGOT PASSWORD</h2>
              <Row>
                <Col lg={6} md={12}>
                  <Form.Group controlId="formGroupEmail">
                    <PageTooltip
                      title="Email"
                      text="Giving us your contact information allows us to contact you if you win a price, set up reminders and send your personalised report."
                        error={this.state.error !== null}
                        error_text={this.state.error}
                    />
                    <Form.Control value={this.state.email} name="email" onChange={this.handleChange} type="email" placeholder="Enter email you used when registering" />
                  </Form.Group>
                </Col>
                <Col lg={12}>
                  <div className='form-submit-btn'>
                    <Button disabled={this.state.button_disable} type="submit" onClick={this.submitForm}>SUBMIT</Button>
                  </div>
                </Col>
                <Col lg={12}>
                  {this.state.recovery_error ?
                    <p style={{ color: "#D21824" }}>We don’t recognise this email address. Please <a href="/contact-us" style={{ color: "#D21824" }} rel="nofollow">contact us</a> to reset your login.</p>
                    : <p className='forget-pass-text'>Did not input your email when registering? Please <a href="/contact-us" rel="nofollow">contact us</a> to reset your login.</p>}
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </div>
      <FooterComp/>
    </Fragment>
  }
}

ForgetPassword.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgetPassword)
